function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from 'react';

var his = function his(_ref) {
  var props = _extends({}, _ref);

  return /*#__PURE__*/React.createElement("svg", {
    width: "40",
    height: "27",
    viewBox: "0 0 40 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0754 1H27.0754V26.0001H13.0754V1Z",
    stroke: "black",
    strokeWidth: "2.00001"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "1",
    y: "3.00002",
    width: "12",
    height: "23.0001",
    stroke: "black",
    strokeWidth: "2.00001"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "26.9999",
    y: "3.00002",
    width: "12",
    height: "23.0001",
    stroke: "black",
    strokeWidth: "2.00001"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "18.0003",
    y: "18.0001",
    width: "4.00002",
    height: "8.00003",
    stroke: "black",
    strokeWidth: "2.00001"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "30.0002",
    y1: "7.00002",
    x2: "36.0002",
    y2: "7.00002",
    stroke: "black",
    strokeWidth: "2.00001"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "30.0002",
    y1: "11",
    x2: "36.0002",
    y2: "11",
    stroke: "black",
    strokeWidth: "2.00001"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "30.0002",
    y1: "15",
    x2: "36.0002",
    y2: "15",
    stroke: "black",
    strokeWidth: "2.00001"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "30.0002",
    y1: "19.0001",
    x2: "36.0002",
    y2: "19.0001",
    stroke: "black",
    strokeWidth: "2.00001"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "4.00005",
    y1: "19.0001",
    x2: "10.0001",
    y2: "19.0001",
    stroke: "black",
    strokeWidth: "2.00001"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "4.00005",
    y1: "15",
    x2: "10.0001",
    y2: "15",
    stroke: "black",
    strokeWidth: "2.00001"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "4.00005",
    y1: "11",
    x2: "10.0001",
    y2: "11",
    stroke: "black",
    strokeWidth: "2.00001"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "4.00005",
    y1: "7.00002",
    x2: "10.0001",
    y2: "7.00002",
    stroke: "black",
    strokeWidth: "2.00001"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.828 5.86669V11.6478H17.334V9.26734H18.257V11.6478H19.763V5.86669H18.257V7.98805H17.334V5.86669H15.828ZM22.7282 7.53463H24.1371C24.1371 6.91388 23.9886 6.46315 23.6917 6.18247C23.4002 5.89638 22.9252 5.75334 22.2667 5.75334C21.6298 5.75334 21.1547 5.90718 20.8417 6.21485C20.5286 6.52253 20.3721 6.97055 20.3721 7.55892C20.3721 7.89898 20.4287 8.17427 20.5421 8.38479C20.6608 8.59531 20.8066 8.76534 20.9793 8.89489C21.1574 9.02444 21.3491 9.1297 21.5542 9.21066C21.7593 9.29163 21.9482 9.3726 22.121 9.45357C22.2991 9.52914 22.4448 9.6236 22.5582 9.73695C22.6769 9.84491 22.7363 9.99335 22.7363 10.1823C22.7363 10.3388 22.6931 10.4711 22.6068 10.579C22.5258 10.687 22.407 10.741 22.2505 10.741C22.1048 10.741 21.986 10.6924 21.8942 10.5952C21.8025 10.4927 21.7566 10.3172 21.7566 10.0689V9.93128H20.2992V10.1337C20.2992 10.436 20.3424 10.6897 20.4287 10.8948C20.5151 11.0999 20.6392 11.2672 20.8012 11.3968C20.9685 11.5209 21.1709 11.6073 21.4084 11.6559C21.6513 11.7099 21.9293 11.7369 22.2424 11.7369C22.9063 11.7369 23.4137 11.5992 23.7646 11.3239C24.1155 11.0432 24.2909 10.5952 24.2909 9.97986C24.2909 9.629 24.2288 9.34561 24.1047 9.1297C23.9859 8.90838 23.8348 8.73025 23.6512 8.59531C23.4677 8.46036 23.2707 8.3524 23.0602 8.27144C22.8497 8.18507 22.6526 8.1014 22.4691 8.02044C22.2856 7.93947 22.1318 7.84501 22.0076 7.73705C21.8888 7.62369 21.8295 7.47255 21.8295 7.28363C21.8295 7.15408 21.8673 7.03803 21.9428 6.93547C22.0184 6.82751 22.1372 6.77353 22.2991 6.77353C22.4448 6.77353 22.5528 6.83561 22.623 6.95976C22.6931 7.07851 22.7282 7.22425 22.7282 7.39698V7.53463Z",
    fill: "black"
  }));
};

export default his;